import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { defaultProps, propTypes } from './fbr.util';
import { FBRPlaceholder } from './FBRPlaceholder';

const ImportedComponent = withDynamicImport({
  server: () => {
    // eslint-disable-next-line
    return __webpack_require__(require.resolveWeak('./FeatureBasedRecommendations.component')).FeatureBasedRecommendations;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "fbr" */
      './FeatureBasedRecommendations.component');
  },
  name: 'FeatureBasedRecommendations',
});

const HydratedComponent = withHydrator({
  delay: 1500,
  id: 'product-section-fbr',
  placeholder: (
    <FBRPlaceholder
      color="#E0E0E0"
      showLoadingAnimation
    />
  ),
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750,
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const FeatureBasedRecommendationsImporter = withLayoutGroup({
  name: 'FBR'
}, DynamicComponent);

FeatureBasedRecommendationsImporter.displayName = 'FeatureBasedRecommendationsImporter';
FeatureBasedRecommendationsImporter.propTypes = propTypes;
FeatureBasedRecommendationsImporter.defaultProps = defaultProps;
